/**
 * The customer an OAuth connection (Search Console, TikTok) was started for.
 *
 * Pinned in sessionStorage at the moment the user clicks Connect rather than read from
 * the workspace context on return: the OAuth round trip is a full-page redirect, and
 * switching the selected customer in another tab in the meantime would otherwise
 * attach the grant to whichever customer happens to be selected when the provider
 * comes back. Keyed per provider so two flows can never spend each other's pin.
 */
const sessionKey = (provider: string) => `${provider}_oauth_customer_id`;

export function rememberOAuthCustomerId(provider: string, customerId: string): void {
  try {
    sessionStorage.setItem(sessionKey(provider), customerId);
  } catch {
    // sessionStorage unavailable (private mode) — the callback falls back to the
    // currently selected customer.
  }
}

export function readOAuthCustomerId(provider: string): string | undefined {
  try {
    return sessionStorage.getItem(sessionKey(provider)) || undefined;
  } catch {
    return undefined;
  }
}

export function clearOAuthCustomerId(provider: string): void {
  try {
    sessionStorage.removeItem(sessionKey(provider));
  } catch {
    /* ignore */
  }
}
